// Material Kit 2 React pages
import Principal from "pages/Principals";

export default function principal() {
  return <Principal />;
}
